import api from "@/shared/services/apiClient";
import { STORAGE_KEYS } from "@/config/constants";
import { storage } from "@/shared/utils/storage";

export const visaService = {
  getStoredUserId: (): string | null => {
    return storage.get(STORAGE_KEYS.USER_ID);
  },

  getUserLegalProfile: async (userId: string) => {
    const response = await api.get(`/profile/user-legal-info/${userId}`);
    return response.data;
  },

  getVisaDropdown: async (lang: string) => {
    const res = await api.get("/sending-org/visa-type", {
      params: { lang },
    });
    return res.data; // Array<{ value: string; label: string }>
  },

  updateVisaInfo: async (userId: string, formData: any) => {
    const payload = {
      ...formData,
      visa_issue_date:
        formData.visa_issue_date instanceof Date
          ? formData.visa_issue_date.toISOString().split("T")[0]
          : formData.visa_issue_date,
      visa_expiry_date:
        formData.visa_expiry_date instanceof Date
          ? formData.visa_expiry_date.toISOString().split("T")[0]
          : formData.visa_expiry_date,
      passport_expiry:
        formData.passport_expiry instanceof Date
          ? formData.passport_expiry.toISOString().split("T")[0]
          : formData.passport_expiry,
      joining_date:
        formData.joining_date instanceof Date
          ? formData.joining_date.toISOString().split("T")[0]
          : formData.joining_date,
      assignment_start_date:
        formData.assignment_start_date instanceof Date
          ? formData.assignment_start_date.toISOString().split("T")[0]
          : formData.assignment_start_date,
    };
    const response = await api.put(`profile/visa-info/${userId}`, payload);
    return response.data;
  },
};

export const notificationService = {
  updateNotificationPreference: async (value: boolean): Promise<void> => {
    await api.patch("/profile/update-notification", { notification: value });
  },
};

export const profileService = {
  getUserProfile: async (userId: string) => {
    const response = await api.get(`/profile/personal-info/${userId}`);
    return response.data;
  },

  updateUserProfile: async (userId: string, profileData: any) => {
    const response = await api.put(`/profile/personal-info/${userId}`, profileData);
    return response.data;
  },

  searchUsers: async (params: {
    company?: string;       // comma-joined IDs
    batch_no?: string;
    name?: string;
    country?: string;       // comma-joined codes
    sending_org?: string;   // comma-joined codes
    visa_type?: string;     // comma-joined codes
    passport_expiry_within?: string;
    visa_expiry_within?: string;
    user_type?: string;     // comma-joined types e.g. "OFFICER,SOUSER"
    status?: "all" | "active" | "inactive";
  }) => {
    const response = await api.get("/profile/search-users", { params });
    return response.data;
  },
};

export const userManagementService = {
  toggleActive: async (userId: string): Promise<{ is_active: boolean }> => {
    const response = await api.patch(`/profile/toggle-active/${userId}`);
    return response.data;
  },

  resetUserPassword: async (userId: string, newPassword: string): Promise<{ message: string }> => {
    const response = await api.patch(`/profile/reset-password/${userId}`, { newPassword });
    return response.data;
  },

  deleteUser: async (userId: string): Promise<{ success: boolean }> => {
    const response = await api.delete(`/login/admin-delete-user/${userId}`);
    return response.data;
  },
};
